// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YFCF","signatureBlock":"Footer_signatureBlock__2qr4O","signature":"Footer_signature__1K_JC"};